import DownloadModal, {
  DownloadModalProps,
} from '@components/shared/Dashboard/HeaderView/DownloadModal';

export type BaseDownloadModalProps = {
  campaignId: string | number;
  campaignName: string;
  renderOpener: DownloadModalProps['renderOpener'];
  onCloserClick: DownloadModalProps['onClose'];
  onOpenerClick: DownloadModalProps['onOpen'];
  isOpen: DownloadModalProps['isOpen'];
  downloadOptions: DownloadModalProps['downloadOptions'];
  footer?: DownloadModalProps['footer'];
};

export const BaseDownloadModal = (props: BaseDownloadModalProps) => {
  const {
    campaignId,
    campaignName,
    renderOpener,
    onCloserClick,
    onOpenerClick,
    isOpen,
    footer,
    downloadOptions,
  } = props;

  return (
    <DownloadModal
      title="Download Campaign Report"
      contentHeader={`${campaignId} - ${campaignName}`}
      contentDescription="Select the type of download you would like:"
      renderOpener={renderOpener}
      maxWidth="lg"
      isOpen={isOpen}
      onClose={onCloserClick}
      onOpen={onOpenerClick}
      footer={footer}
      downloadOptions={downloadOptions}
    />
  );
};
